function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Drop the organization name that follows the greeting. Matches the backend
 * helper in smartflow-api/utils/senderContactHtml.js.
 */
export function stripClosingOrganizationName(html, organizationName) {
  const names = ['[organization_name]'];
  if (organizationName) names.push(String(organizationName));
  let result = html || '';
  names.forEach((name) => {
    const escaped = escapeRegExp(name);
    const inline = new RegExp(
      `((?:Met vriendelijke groet|Kind regards),\\s*(?:<br\\s*/?>|\\r?\\n)\\s*)${escaped}`,
      'gi',
    );
    const paragraph = new RegExp(
      `<p>\\s*((?:Met vriendelijke groet|Kind regards),)\\s*</p>\\s*<p>\\s*${escaped}\\s*</p>`,
      'gi',
    );
    result = result.replace(paragraph, '<p>$1</p>').replace(inline, '$1');
  });
  return result;
}

export function mailIncludesSenderSignature(html) {
  return /\[handtekening_gebruiker\]/i.test(html || '');
}
